// Toggle admin menu

jQuery('.toggle-admin-menu').on('click',function(e){
	e.preventDefault();
	jQuery('#wpadminbar').slideToggle(150);
	jQuery('html').toggleClass('no-margin');
	jQuery(this).toggleClass('fixed-top');
});